import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './ThankYouEdition2Page.module.css';

const ThankYouEdition2Page: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Brands2Buyers - Édition 2 - Merci !</title>
        <meta property="og:title" content="Brands2Buyers - Édition 2 - Merci !" />
        <meta name="twitter:title" content="Brands2Buyers - Édition 2 - Merci !" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* Hero */}
      <section className={styles.heroSection}>
        <div className={styles.heroContainer}>
          <h1 className={styles.heroTitle}>BRANDS2BUYERS édition 2</h1>
          <p className={styles.heroSubtitle}>ON L'A FAIT !</p>
        </div>
      </section>

      {/* Intro — fond blanc */}
      <section className={styles.introSection}>
        <div className={styles.introInner}>
          <h1 className={styles.introH1}>Merci pour cette édition mémorable !</h1>
          <p className={styles.introP}>
            Votre présence, vos questions et vos échanges ont donné toute son énergie à cette 2ᵉ édition de Brands2Buyers...
          </p>
          <ul className={styles.introList}>
            <li>Des top décideurs B2B qui sont sortis de leurs bureaux !</li>
            <li>Des sponsors qui déchirent : Algolia, Salesforce et Spoon Consulting 🫶</li>
            <li>Une keynote d'ouverture menée par Laetitia, Adrien et Rudy Abitbol pour décrypter 2025 et ouvrir les perspectives 2026</li>
            <li>Une table ronde avec Emir Belkahia, Amélie Maréchal et Amal Dopchie sur la modernisation du B2B, l'IA agentique et l'expérience digitale de demain</li>
            <li>Une seconde table ronde réunissant Benjamin Boyer et Soumaya Hamzaoui autour de l'agilité, des intégrations et de la transformation des organisations B2B</li>
            <li>Un fireside chat inspirant avec Yohan Grillot et Cyrille Groult autour de la digitalisation industrielle, de la valeur ajoutée et de l'usine du futur</li>
            <li>Des animations, des surprises et un networking final qui ont prolongé les conversations</li>
          </ul>
        </div>
      </section>

      {/* Now what? */}
      <section className={styles.nowWhatSection}>
        <div className={styles.nowWhatInner}>
          <h1 className={styles.nowWhatTitle}>Now what?</h1>

          <h1 className={styles.nowWhatSubtitle}>Revivez les temps forts avec les photos de la soirée :</h1>
          <p className={styles.nowWhatText}>(La vidéo arrive très vite promis !)</p>
          <a
            href="https://photos.app.goo.gl/hWqipGDMTaU3tZHz6"
            target="_blank"
            rel="noreferrer"
            className={styles.nowWhatBtn}
          >
            Voir l'album
          </a>

          <h1 className={styles.nowWhatSubtitle}>Vous souhaitez partager toutes les tendances abordées ?</h1>
          <p className={styles.nowWhatText}>
            <a href="https://drive.google.com/file/d/1PJdEzC26bKDHALYeJWmiBu4X5_KRdqHK/view" target="_blank" rel="noreferrer">Voir la présentation</a>
            {' '}|{' '}
            <a href="https://www.calameo.com/read/007862432de0f2263a779" target="_blank" rel="noreferrer">Lire le Magazine</a>
          </p>

          <h1 className={styles.nowWhatSubtitle}>Donnez-nous votre feedback please !</h1>
          <p className={styles.nowWhatText}>
            <a href="mailto:hello@brands2buyers.io">hello@brands2buyers.io</a>
          </p>

          <h1 className={styles.nowWhatSubtitle}>Inscrivez-vous pour l'édition 3 !</h1>
          <p className={styles.nowWhatText}>L'aventure continue : rendez-vous pour l'édition 3...</p>
          <a
            href="https://www.brands2buyers.io/inscriptions"
            target="_blank"
            rel="noreferrer"
            className={styles.nowWhatBtn}
          >
            Inscription
          </a>
        </div>
      </section>

      {/* WhatsApp — fond violet */}
      <section className={styles.whatsappSection}>
        <div className={styles.whatsappInner}>
          <div className={styles.whatsappTextBlock}>
            <h1 className={styles.whatsappTitle}>Rejoignez le groupe WhatsApp Brands2Buyers !</h1>
            <div className={styles.whatsappText}>
              Un espace réservé aux participants pour :<br />
              • partager vos actualités et vos besoins<br />
              • rester en contact avec les marques et partenaires présents<br />
              • retrouver les ressources et informations clés de l'évènement<br />
              • être informé(e) en avant-première des prochaines éditions.
            </div>
            <a
              href="https://chat.whatsapp.com/KN6a2NAqGUB6pHnjqvFqin"
              target="_blank"
              rel="noreferrer"
              className={styles.whatsappBtn}
            >
              Rejoindre le groupe !
            </a>
          </div>
          <div className={styles.whatsappImage}>
            <img
              src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/670f9cc9a04d7cedcfa9e171_AlbedoBase_XL_90s_mobile_social_media_0.jpg"
              loading="lazy"
              alt="WhatsApp"
            />
          </div>
        </div>
      </section>

      {/* Noël — fond jaune */}
      <section className={styles.noelSection}>
        <div className={styles.noelInner}>
          <h1 className={styles.noelTitle}>Retrouvez-nous pour fêter Noël !</h1>
          <img
            src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/6934556cb5c43e3aa002d6de_Bannie%CC%80res%20events%20LI%20(10).png"
            alt="Noël Brands2Buyers"
            className={styles.noelImage}
            loading="lazy"
          />
          <a
            href="https://www.linkedin.com/events/7368403282806861825/"
            target="_blank"
            rel="noreferrer"
            className={styles.noelBtn}
          >
            Infos et inscriptions
          </a>
        </div>
      </section>

      {/* Communauté — fond rose */}
      <section className={styles.communauteSection}>
        <div className={styles.communauteInner}>
          <h1 className={styles.communauteTitle}>Rejoignez la communauté !</h1>
          <div className={styles.communauteText}>
            Nous avons secoué l'e-commerce et fédéré une vraie tribu : une communauté de milliers
            de passionnés qui suivent chaque jour l'e-commerce qui bouge. Rejoignez nos groupes
            pour papoter tendances, partager vos galères, vos victoires… et ne plus jamais
            brainstormer tout seul !
          </div>
          <div className={styles.communauteImages}>
            <a href="https://chat.whatsapp.com/K0EV7FJH29BEMYxQFgO9e3" target="_blank" rel="noreferrer">
              <img
                src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/693458f4c9ec48264e94ebe7_684bea8c000512a9d85c56d3_1.jpg"
                loading="lazy"
                alt="Communauté WhatsApp 1"
              />
            </a>
            <a href="https://chat.whatsapp.com/IrSzW75IfsUFIAKnTbGYPA" target="_blank" rel="noreferrer">
              <img
                src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/693458f48b0d508ece27359e_684bea8c4604b4f162f6185c_2.jpg"
                loading="lazy"
                alt="Communauté WhatsApp 2"
              />
            </a>
          </div>
        </div>
      </section>

      {/* Signature */}
      <section className={styles.signatureSection}>
        <div className={styles.signatureInner}>
          <h1 className={styles.signatureTitle}>Adrien, Laetitia &amp; la B2B Squad</h1>
        </div>
      </section>
    </>
  );
};

export default ThankYouEdition2Page;
